// ProtectedRoute.jsx
import React, { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Login from '../../pages/Login/Login';
import PendingApproval from '../../pages/PendingApproval/PendingApproval';

const ProtectedRoute = ({ children, adminOnly = false, allowPending = false }) => {
  const { currentUser, isApproved, isAdmin, loading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  
  // Handle the case where we're redirected to login page after successful auth
  useEffect(() => {
    const redirectInProgress = localStorage.getItem('googleAuthRedirectInProgress');
    const redirectTimestamp = localStorage.getItem('googleAuthTimestamp');
    
    const isValidRedirect = redirectInProgress && redirectTimestamp && 
      (Date.now() - parseInt(redirectTimestamp)) < 300000; // 5 minutes
    
    if (currentUser && isValidRedirect) {
      localStorage.removeItem('googleAuthRedirectInProgress');
      localStorage.removeItem('googleAuthTimestamp');
      navigate('/', { replace: true });
    } else if (redirectInProgress && !isValidRedirect) {
      localStorage.removeItem('googleAuthRedirectInProgress');
      localStorage.removeItem('googleAuthTimestamp');
    }
  }, [currentUser, navigate]);

  if (loading) {
    return (
      <div className="global-loading-container">
        <div className="loading-spinner"></div>
        <p>Verifying Credentials before the Bar...</p>
      </div>
    );
  }

  // If no user, show the Login component
  if (!currentUser) {
    if (location.pathname !== '/login') {
      localStorage.setItem('authRedirectPath', location.pathname);
    }
    return <Login />;
  }

  // If user is pending approval and this route doesn't allow pending users, show Waiting Room
  if (!allowPending && !isApproved && !isAdmin) {
    return <PendingApproval />;
  }

  // Check for admin access if required
  if (adminOnly && !isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
